import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import notification from './modules/notification'
import agency from './modules/agency'
import agent from './modules/agent'
import contract from './modules/contract'
import languages from './modules/languages'
import paymentPlans from './modules/paymentPlans'

import abilityUpdater from './plugins/abilityUpdater'

Vue.use(Vuex)

export default new Vuex.Store({

  plugins: [
    abilityUpdater
  ],

  modules: {
    user,
    agency,
    agent,
    contract,
    notification,
    languages,
    paymentPlans
  }
})
